<div class="width-1100">

  <mat-card>
    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>dashboard_customize</mat-icon>
        <div>Anuidades</div>
      </div>

      <div flex justify-content='flex-end' fxLayoutAlign="end">


        <input class='filter' matInput (keyup)="applyFilter($event.target.value)" placeholder='filtro'
          autocomplete="off">

        <a mat-button (click)="openDialog(null)" style='width:60px;'>
          <mat-icon color='primary'>add_circle_outline</mat-icon>
        </a>

      </div>

    </mat-toolbar>

  </mat-card>

  <mat-card>
    <!-- TABLE -->
    <mat-table [dataSource]="_annuityService.productDataSource" #activeSort="matSort" matSort
      matSortDisableClear='true'>

      <!-- Icon Column -->
      <ng-container matColumnDef="icon">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-icon style='font-size:1.2em; margin-top:10px;'>dashboard_customize</mat-icon>
        </mat-cell>
      </ng-container>

      <!-- name Column -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Annuidade </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span>
            {{ element.name }}
          </span>
           <span *ngIf="element.deleted">
            {{' - '}}(apenas admin)
           </span>
          
          </mat-cell>
      </ng-container>

      <!-- edit Column -->
      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='openDialog(element)' style='background-color: whitesmoke;'>
            <mat-icon class='icon-info' style='font-size:1.5em;'>
              info_outline
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>

      <!-- report Column -->
      <ng-container matColumnDef="report">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='gotoReport(element)' style='background-color: whitesmoke;'>
            <mat-icon class='icon-cancel' style='font-size:1.5em;'>list_alt
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>


      <!-- Header -->
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

      <!-- Row -->
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>
    <!-- END TABLE -->

  </mat-card>

</div>